module.exports = __webpack_public_path__ + "img/add_bg_img.c4545b32.svg";